import { externalApi } from "./externalClient";

const PAYSTACK_BASE_URL = "https://api.paystack.co";

export type PaystackChargeResponse = {
  status: boolean;
  message: string;
  data: any;
};

export async function paystackCreateBankTransfer(payload: {
  email: string;
  amountKobo: number;
  expiresAtISO: string;
  metadata?: Record<string, unknown>;
}) {
  // TEMPORARY: key in env. Move to backend-mode long-term so the secret never ships to the browser.
  const secret = process.env.REACT_APP_PAYSTACK_SECRET_KEY;

  if (!secret) {
    throw new Error("Paystack secret key is missing in env (REACT_APP_PAYSTACK_SECRET_KEY).");
  }

  const body: Record<string, unknown> = {
    email: payload.email,
    amount: String(payload.amountKobo),
    bank_transfer: {
      account_expires_at: payload.expiresAtISO,
    },
  };

  if (payload.metadata) {
    body.metadata = payload.metadata;
  }

  const res = await externalApi.post<PaystackChargeResponse>(
    `${PAYSTACK_BASE_URL}/charge`,
    body,
    {
      headers: {
        Authorization: `Bearer ${secret}`,
      },
    },
  );

  return res.data;
}
